import {Model} from "@/app/Model";
import type {
    KeyValoreNum,
    KeyValoreStr,
    KeyValoreStrNum,
    KeyValoreStrNumArr,
    KeyValoreStrNumBool
} from "@/app/data/DataTypes";

export class ResponsabilitaData {
    
    public durata_del_processo: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0}; 
    public durata_del_processo_per_singola_citta: KeyValoreStrNum[] = [];
    public tipologia_danno_per_citta: KeyValoreStrNumArr[] = [];
    public sentenze_paginate: KeyValoreStrNum[] = [];
    public sentenze_paginate_jump: KeyValoreStrNum[] = [];
    public sentenze_paginate_jump_display: KeyValoreStrNum[] = [];
    public tipologia_danno: KeyValoreStrNum[] = [];
    public tipologia_danno_patrimoniale: KeyValoreStrNum[] = [];
    public tipologia_danno_non_patrimoniale: KeyValoreStrNum[] = [];

    public totale_numero_sentenze: KeyValoreNum = {"valore": 0};
    public totale_sentenze_per_tribunale: KeyValoreStrNum[] = [];

    public risarcimento_richiesto: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0};
    public risarcimento_disposto_totale: KeyValoreNum = {"valore": 0, "valore_min": 0, "valore_max": 0};

    public risarcimento : KeyValoreStrNum[] = [];
    public domanda_accolta : KeyValoreStrNumBool[] = [];

    public totale_giudici: KeyValoreStr[] = []; //{ "giudice": "zzz" }
    public totale_citta: KeyValoreStr[] = []; //{ "citta": "zzz", "id_localita": "234234" }

    constructor(json: any = null) {
        if (json && json.data && json.data.pgQuery && json.data.pgQuery.list && json.data.pgQuery.list.length > 0 && json.data.pgQuery.list[0].result) {
            let useJson: any = json.data.pgQuery.list[0].result;

            if (useJson["durata_del_processo"]) this.durata_del_processo = useJson["durata_del_processo"];
            if (useJson["totale_numero_sentenze"]) this.totale_numero_sentenze = useJson["totale_numero_sentenze"];
            if (useJson["tipologia_danno_per_citta"]) this.tipologia_danno_per_citta = useJson["tipologia_danno_per_citta"];
            
            if (useJson["sentenze_paginate"]) this.sentenze_paginate = useJson["sentenze_paginate"];
            if (useJson["sentenze_paginate_jump"]) this.sentenze_paginate_jump = useJson["sentenze_paginate_jump"];
            if (useJson["durata_del_processo_per_singola_citta"]) this.durata_del_processo_per_singola_citta = useJson["durata_del_processo_per_singola_citta"];
            if (useJson["totale_sentenze_per_tribunale"]) this.totale_sentenze_per_tribunale = useJson["totale_sentenze_per_tribunale"];

            if (useJson["tipologia_danno"]) this.tipologia_danno = useJson["tipologia_danno"];
            if (useJson["tipologia_danno_patrimoniale"]) this.tipologia_danno_patrimoniale = useJson["tipologia_danno_patrimoniale"];
            if (useJson["tipologia_danno_non_patrimoniale"]) this.tipologia_danno_non_patrimoniale = useJson["tipologia_danno_non_patrimoniale"];

            if (useJson["risarcimento_richiesto"]) this.risarcimento_richiesto = useJson["risarcimento_richiesto"];
            if (useJson["risarcimento_disposto_totale"]) this.risarcimento_disposto_totale = useJson["risarcimento_disposto_totale"];

            if (useJson["risarcimento"]) this.risarcimento = useJson["risarcimento"];
            if (useJson["domanda_accolta"]) this.domanda_accolta = useJson["domanda_accolta"];

            if (useJson["totale_giudici"]) this.totale_giudici = useJson["totale_giudici"];
            if (useJson["totale_citta"]) this.totale_citta = useJson["totale_citta"];

            updateModel(this);

            function updateModel(that: ResponsabilitaData): void {
                let model: Model = Model.getInstance();

                that.sentenze_paginate_jump_display = that.sentenze_paginate_jump.slice(0, model.res_flow_dashboard.diritto_paginazione_rows);

                model.res_flow_percorso.paginazione_tot = that.totale_numero_sentenze.valore;
                model.res_flow_percorso.paginazione_pages = Math.ceil(that.totale_numero_sentenze.valore / model.res_flow_dashboard.paginazione_rows) -1;
                if (model.res_flow_percorso.paginazione_start > model.res_flow_percorso.paginazione_pages) {
                    model.res_flow_percorso.paginazione_start = model.res_flow_percorso.paginazione_pages;
                }

                model.res_flow_dashboard.diritto_paginazione_start = 0;
                model.res_flow_dashboard.diritto_paginazione_tot = that.sentenze_paginate_jump.length;
                model.res_flow_dashboard.diritto_paginazione_pages = Math.ceil(model.res_flow_dashboard.diritto_paginazione_tot / model.res_flow_dashboard.diritto_paginazione_rows) -1;

                model.res_flow_dashboard.paginazione_tot = that.totale_numero_sentenze.valore;
                model.res_flow_dashboard.paginazione_pages = Math.ceil(that.totale_numero_sentenze.valore / model.res_flow_dashboard.paginazione_rows) -1;
                if (model.res_flow_dashboard.paginazione_start > model.res_flow_dashboard.paginazione_pages) {
                    model.res_flow_dashboard.paginazione_start = model.res_flow_dashboard.paginazione_pages;
                }

                model.res_flow_percorso.diritto_paginazione_start = 0;
                model.res_flow_percorso.diritto_paginazione_tot = that.sentenze_paginate_jump.length;
                model.res_flow_percorso.diritto_paginazione_pages = Math.ceil(model.res_flow_percorso.diritto_paginazione_tot / model.res_flow_percorso.diritto_paginazione_rows) -1;

                model.res_flow_dashboard.data_min = Model.lista_anno_minMax[0];
                model.res_flow_dashboard.data_max = Model.lista_anno_minMax[1];

                if (model.res_flow_dashboard.data_da < model.res_flow_dashboard.data_min) model.res_flow_dashboard.data_da = model.res_flow_dashboard.data_min;
                if (model.res_flow_dashboard.data_a < model.res_flow_dashboard.data_min) model.res_flow_dashboard.data_a = model.res_flow_dashboard.data_min;
                if (model.res_flow_dashboard.data_a > model.res_flow_dashboard.data_max || model.res_flow_dashboard.data_a == 0) {
                    model.res_flow_dashboard.data_a = model.res_flow_dashboard.data_max;
                }



                model.res_flow_dashboard.risarcimento_richiesto_min = that.risarcimento_richiesto.valore_min;
                model.res_flow_dashboard.risarcimento_richiesto_max = that.risarcimento_richiesto.valore_max;

                if (model.res_flow_dashboard.risarcimento_richiesto_da < model.res_flow_dashboard.risarcimento_richiesto_min) {
                    model.res_flow_dashboard.risarcimento_richiesto_da = model.res_flow_dashboard.risarcimento_richiesto_min;
                }
                if (model.res_flow_dashboard.risarcimento_richiesto_a < model.res_flow_dashboard.risarcimento_richiesto_min) {
                    model.res_flow_dashboard.risarcimento_richiesto_a = model.res_flow_dashboard.risarcimento_richiesto_min;
                }
                if (model.res_flow_dashboard.risarcimento_richiesto_a > model.res_flow_dashboard.risarcimento_richiesto_max ||
                    model.res_flow_dashboard.risarcimento_richiesto_a == 0) {
                    model.res_flow_dashboard.risarcimento_richiesto_a = model.res_flow_dashboard.risarcimento_richiesto_max;
                }

                model.res_flow_dashboard.risarcimento_disposto_totale_min = that.risarcimento_disposto_totale.valore_min;
                model.res_flow_dashboard.risarcimento_disposto_totale_max = that.risarcimento_disposto_totale.valore_max;

                if (model.res_flow_dashboard.risarcimento_disposto_totale_da < model.res_flow_dashboard.risarcimento_disposto_totale_min) {
                    model.res_flow_dashboard.risarcimento_disposto_totale_da = model.res_flow_dashboard.risarcimento_disposto_totale_min;
                }
                if (model.res_flow_dashboard.risarcimento_disposto_totale_a < model.res_flow_dashboard.risarcimento_disposto_totale_min) {
                    model.res_flow_dashboard.risarcimento_disposto_totale_a = model.res_flow_dashboard.risarcimento_disposto_totale_min;
                }
                if (model.res_flow_dashboard.risarcimento_disposto_totale_a > model.res_flow_dashboard.risarcimento_disposto_totale_max ||
                    model.res_flow_dashboard.risarcimento_disposto_totale_a == 0) {
                    model.res_flow_dashboard.risarcimento_disposto_totale_a = model.res_flow_dashboard.risarcimento_disposto_totale_max;
                }

            }
        }
    }
}